import { useMemo } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../../../../../consts";
import { t } from "../../../../../../../../services";
import { changeHistoryUtils } from "../../../../../../../../utils";

import { changeHistoryTypes } from "../../../../../consts/changeHistoryTypes";

import { HistoryItemStyled, ActionInfo, Circle, DateInfo } from "./styled";

export const HistoryItem = ({ record, isFirstRecord, isLastRecord }) => {
  const action = useMemo(() => {
    switch (record.type) {
      case changeHistoryTypes.userCreation:
        return strCode.CREATED_USER_ACCOUNT_ACTION;
      case changeHistoryTypes.userDeletion:
        return strCode.DELETED_USER_ACCOUNT_ACTION;
      case changeHistoryTypes.userChange:
        return strCode.ADDED_CHANGES_ACTION;
      case changeHistoryTypes.userPasswordReset:
        return strCode.RESET_PASSWORD_ACTION;
      default:
        return "";
    }
  }, [record]);
  return (
    <HistoryItemStyled isFirstRecord={isFirstRecord} isLastRecord={isLastRecord}>
      <Circle isFirstRecord={isFirstRecord} />
      <DateInfo>{changeHistoryUtils.formatDateFromTimestamp(record.timestamp)}</DateInfo>
      <ActionInfo>
        <b>{record.adminEmail}</b> {t(action)}
      </ActionInfo>
    </HistoryItemStyled>
  );
};

HistoryItem.propTypes = {
  record: PropTypes.shape({
    timestamp: PropTypes.number.isRequired,
    adminEmail: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  isFirstRecord: PropTypes.bool.isRequired,
  isLastRecord: PropTypes.bool.isRequired
};
